module.exports = __webpack_public_path__ + "a8ca4dc8fd3a6db9920a3860fdfe003a.pdf";